import React from 'react';
import '@ali/infinite-webui/es/web-components/Button/button.css';
import Resize from '@ali/arise-h5-utils-img';
import { cls } from '../../utils';
import styles from './index.module.scss';

const bgUrl = Resize.getFitUrl(
  'https://img.mrvcdn.com/g/tps/imgextra/i2/O1CN01SuW56B1rZSa9X3UGS_!!6000000005645-0-tps-3960-546.jpg',
  2000,
  100
);

const statusCode = {
  default: 'default',
  success: 'success',
  collectResult: 'collectResult', // collectResult for error case 1
  toastMsg: 'toastMsg', // toastMsg for error case 2, collectResult no value
  collected: 'collected', // received but not used
};

function Voucher({ data, collectResult }) {
  if (!data.ticket?.config) {
    return null;
  }
  const {
    value,
    couponTitle,
    subTitle,
    subDescription,
    pop,
    voucherStatus,
    platformTitle,
    platformSubTitle,
  } = data.ticket;
  const { spmd, trackingParam, clickArgs, exposeArgs } = data.userTrack || {};
  const { tcBtnText, termsAndConditions } = pop || {};
  const status =
    voucherStatus === 'COLLECTED' ? statusCode.collected : statusCode.default;

  return (
    <div
      className={cls([styles.voucher, styles.single])}
      style={{
        background: `url(${bgUrl}) center top/cover no-repeat`,
        backgroundColor: '#edebfd',
      }}
    >
      <div
        className={cls([styles.voucherInner, 'auto-evt'])}
        data-spm={`d${spmd}`}
        data-params-exp={JSON.stringify(exposeArgs)}
        data-params-clk={JSON.stringify(clickArgs)}
        trackingParam={JSON.stringify(trackingParam)}
      >
        {!collectResult && (
          <React.Fragment>
            <div className={cls([styles.voucherLeft, styles.voucherVal])}>
              <div className={cls([styles.voucherValWrap, 'one-line-clamp'])}>
                {value.type === 'discount' ? (
                  <span className={styles.voucherValNum}>
                    {value.discountValue}%
                  </span>
                ) : (
                  <React.Fragment>
                    <span className={styles.voucherValNum}>
                      {value.valueFloor}
                    </span>
                    <span>{`${value.valueDecimal}${value.currency}`}</span>
                  </React.Fragment>
                )}
              </div>
              <span className={cls([styles.voucherValOff, 'one-line-clamp'])}>
                {value.type === 'discount'
                  ? value.discountSuffix
                  : value.valueDes}
                {platformTitle && ` ${platformTitle}`}
              </span>
              {platformSubTitle && (
                <div
                  className={cls([
                    styles.voucherPlatformSubTitle,
                    'one-line-clamp',
                  ])}
                >
                  {platformSubTitle}
                </div>
              )}
            </div>
            <div className={styles.voucherWrap}>
              <div
                className={cls([
                  styles.voucherCenter,
                  status === statusCode.collectResult && styles.voucherFail,
                ])}
              >
                <div className={`${styles.voucherTitle} one-line-clamp`}>
                  {couponTitle}
                </div>
                <div className={`${styles.voucherSub} one-line-clamp`}>
                  {subTitle}
                </div>
                <div className={`${styles.voucherSub} one-line-clamp`}>
                  {subDescription}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        {collectResult && (
          <div className={styles.voucherError}>
            <div
              className={cls([styles.voucherCollectResult, 'two-line-clamp'])}
            >
              {collectResult}
            </div>
          </div>
        )}
      </div>
      {tcBtnText && (
        <div
          className={cls([styles.voucherTcBtn, 'auto-evt'])}
          data-spm="dtc"
          data-params-exp={JSON.stringify(exposeArgs)}
          data-params-clk={JSON.stringify(clickArgs)}
          trackingParam={JSON.stringify(trackingParam)}
          onClick={() => {
            if (window.jsapi?.promotion?.aboutCoupon) {
              window.jsapi.promotion.aboutCoupon({
                aboutCouponDialog: {
                  visible: false,
                },
                termsAndConditionsDialog: {
                  visible: true,
                  title: tcBtnText,
                  contents: termsAndConditions,
                },
              });
            }
          }}
        >
          {tcBtnText}
        </div>
      )}
    </div>
  );
}

export default Voucher;
